import styled, { keyframes } from "styled-components";

const rotate = keyframes`
  from {
   transform: rotate(0deg);
  }
  to {
   transform: rotate(360deg);
  }
`;

export const SpinnerContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  line-height: 1;
`;

export const SpinnerWrapper = styled.div`
  animation: ${rotate} 1.5s linear infinite;
  width: 100%;
  height: 100%;
`;
